<template lang="pug">
div.notify(:class="'notify-' + options.position", :style="{width: width}")
  transition-group(name="notify", tag="div")
    div.notify-item(v-for="item in items", :key="item.idx")
      div(:class="item.options.itemClass")
        icon(v-if="item.options.iconClass", :icon="item.options.iconClass")
        button(v-if="item.options.closeButtonClass", :class="item.options.closeButtonClass", type="button", aria-label="Close", @click="removeItem(item.idx)"): icon(icon="times")
        div(v-html="item.text")
</template>

<script>
import Vue from 'vue'

import {escape} from 'lodash-es'

export default {
  data () {
    return {
      types: {
        info: {itemClass: 'alert-info', iconClass: 'info-circle'},
        error: {itemClass: 'alert-danger', iconClass: 'exclamation-circle'},
        warning: {itemClass: 'alert-warning', iconClass: 'exclamation-circle'},
        success: {itemClass: 'alert-success', iconClass: 'check-circle'}
      },
      options: {
        itemClass: 'alert',
        duration: 500,
        visibility: 2000,
        position: 'top-right',
        enter: 'slideDown',
        leave: 'slideUp',
        closeButtonClass: false,
        width: '300px',
        mode: 'text',
        permanent: false
      },
      items: {},
      idx: 0
    }
  },
  computed: {
    width () {
      return this.options.width
    }
  },
  methods: {
    setTypes (types) {
      this.types = types
    },
    addItem (type, msg, options) {
      let defaultOptions = {
        iconClass: this.types[type].iconClass,
        itemClass: [this.options.itemClass, this.types[type].itemClass],
        visibility: this.options.visibility,
        mode: this.options.mode,
        closeButtonClass: this.options.closeButtonClass,
        permanent: this.options.permanent
      }
      let itemOptions = Object.assign({}, defaultOptions, options)

      // get idx
      let idx = this.idx

      // check if this message is already shown
      for (let key in this.items) {
        /* istanbul ignore else */
        if (this.items.hasOwnProperty(key)) {
          if (this.items[key].text === msg) {
            return
          }
        }
      }

      // add it to the queue (if it's not already there)
      Vue.set(this.items, this.idx, { idx: `notification-${idx}`, ype: type, text: escape(msg).replace(/[*]{2}([^\*]+)[*]{2}/g, '<strong>$1</strong>'), options: itemOptions })

      // increment key
      this.idx++

      // remove item if not permanent
      if (itemOptions.permanent === false) {
        // remove item from array
        setTimeout(() => { this.removeItem(idx) }, this.options.duration + itemOptions.visibility)
      }
    },
    removeItem (index) {
      Vue.delete(this.items, index)
    },
    removeAll () {
      this.items = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.notify {
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 1000;
}
.notify .alert {
  margin: 0;
}
.notify-item {
  margin-bottom: 5px
}
.notify-enter-active {
  transition: all .3s ease;
}
.notify-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.notify-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
